import React, { useState } from 'react';

import { Box, Text, Textarea, HStack, Checkbox } from '@chakra-ui/react';

import TextareaAutosize from 'react-textarea-autosize';

import { useColors } from './colors';

const ListingDescription = ({ listing, onUpdate }) => {
  const [description, setDescription] = useState(
    listing?.marketplaceDetails?.description || '',
  );
  const [showHtmlCode, setShowHtmlCode] = useState(false);

  const {
    bgColor,
    borderColor,
    headingColor,
    toolbarBg,
    iconColor,
    previewBg,
    previewTextColor,
  } = useColors();

  const handleDescriptionChange = (e) => {
    const newDescription = e.target.value;
    setDescription(newDescription);
    onUpdate?.({ description: newDescription });
  };

  return (
    <Box
      bg={bgColor}
      borderRadius="xl"
      p={6}
      border="1px solid"
      borderColor={borderColor}
    >
      <Text fontSize="xl" fontWeight="semibold" color={headingColor} mb={6}>
        DESCRIPTION
      </Text>

      {/* Toolbar */}
      <Box
        bg={toolbarBg}
        borderRadius="md"
        p={3}
        mb={4}
        border="1px solid"
        borderColor={borderColor}
      >
        <HStack spacing={2} wrap="wrap">
          <Box ml="auto">
            <Checkbox
              isChecked={showHtmlCode}
              onChange={(e) => setShowHtmlCode(e.target.checked)}
              colorScheme="blue"
              size="sm"
            >
              <Text fontSize="sm" color={iconColor}>
                Show HTML Code
              </Text>
            </Checkbox>
          </Box>
        </HStack>
      </Box>

      <Box
        border="1px solid"
        borderColor={borderColor}
        borderRadius="md"
        overflow="hidden"
        height="500px"
      >
        {showHtmlCode ? (
          <Textarea
            as={TextareaAutosize}
            value={description}
            onChange={handleDescriptionChange}
            placeholder="Enter HTML description..."
            minRows={15}
            resize="vertical"
            border="none"
            borderRadius="0"
            fontFamily="monospace"
            fontSize="sm"
            _focus={{
              boxShadow: 'none',
            }}
            height="100%"
            bg={previewBg}
            overflowY="auto"
          />
        ) : (
          <Box
            position="relative"
            bg={previewBg}
            height="100%"
            p={4}
            color={previewTextColor}
            overflowY="auto"
          >
            {description ? (
              <Box
                dangerouslySetInnerHTML={{ __html: description }}
                sx={{
                  '& img': {
                    maxWidth: '100%',
                    height: 'auto',
                  },
                  '& p': {
                    marginBottom: '1em',
                  },
                  '& h1, & h2, & h3, & h4, & h5, & h6': {
                    marginBottom: '0.5em',
                    fontWeight: 'bold',
                  },
                  '& ul, & ol': {
                    marginLeft: '2em',
                    marginBottom: '1em',
                  },
                  '& li': {
                    marginBottom: '0.25em',
                  },
                  '& a': {
                    color: 'blue.500',
                    textDecoration: 'underline',
                  },
                  '& table': {
                    borderCollapse: 'collapse',
                    width: '100%',
                    marginBottom: '1em',
                  },
                  '& td, & th': {
                    border: '1px solid #ddd',
                    padding: '8px',
                    textAlign: 'left',
                  },
                  '& th': {
                    backgroundColor: '#f2f2f2',
                    fontWeight: 'bold',
                  },
                }}
              />
            ) : (
              <Text color="gray.500" fontStyle="italic">
                No description available
              </Text>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ListingDescription;
